import { ref, readonly } from 'vue'
import { languages, defaultLocale, supportedCodes } from './languages.js'

import zhCN from './locales/zh-CN.json'
import zhTW from './locales/zh-TW.json'
import en from './locales/en.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import pt from './locales/pt.json'
import ru from './locales/ru.json'
import uk from './locales/uk.json'
import ar from './locales/ar.json'
import it from './locales/it.json'
import tr from './locales/tr.json'
import pl from './locales/pl.json'
import vi from './locales/vi.json'
import th from './locales/th.json'
import hi from './locales/hi.json'
import id from './locales/id.json'

const messages = { 'zh-CN': zhCN, 'zh-TW': zhTW, en, ja, ko, es, fr, de, pt, ru, uk, ar, it, tr, pl, vi, th, hi, id }
const STORAGE_KEY = 'nav_lang'

function detectLocale() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved && supportedCodes.includes(saved)) return saved
  const nav = navigator.language || ''
  if (supportedCodes.includes(nav)) return nav
  const prefix = nav.split('-')[0]
  const match = supportedCodes.find(c => c === prefix || c.startsWith(prefix + '-'))
  return match || defaultLocale
}

const locale = ref(detectLocale())

function setLocale(code) {
  if (!supportedCodes.includes(code)) return
  locale.value = code
  localStorage.setItem(STORAGE_KEY, code)
  document.documentElement.lang = code
  document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr'
}

function t(key, params) {
  const chain = messages[locale.value] || messages[defaultLocale]
  const fallback = messages[defaultLocale]
  let val = key.split('.').reduce((o, k) => o?.[k], chain)
  if (val === undefined) val = key.split('.').reduce((o, k) => o?.[k], fallback)
  if (val === undefined) return key
  if (params) return val.replace(/\{(\w+)\}/g, (_, k) => params[k] ?? '')
  return val
}

document.documentElement.lang = locale.value
document.documentElement.dir = locale.value === 'ar' ? 'rtl' : 'ltr'

export function useI18n() {
  return { t, locale: readonly(locale), setLocale, languages }
}
